import React from 'react';
import { observer } from 'mobx-react';
import { OEToggle } from '../../global/oe-toggle/oe-toggle';
import Text from '../../global/text/text';
import { CommonPopupBodyFooterLayout } from '../../global/common-popup/common-popup-body-footer-layout';
import { AccountAdminSettingFormFooter } from '../common/account-admin-setting-form-footer';
import { SEGREGATED_DATA_ENCRYPTION_CLIENTS_INFO_TEXT, SEGREGATED_DATA_ENCRYPTION_INFO_TEXT, SEGREGATED_DATA_ENCRYPTION_TOGGLE_TEXT } from '../account-admin.text';
import { SegregatedDataEncryptionFormVM } from './segregated-data-encryption-form.viewmodel';
import { FormattedMessage } from 'react-intl';

interface ISegregatedDataEncryptionFormPresentationProps {
    vm: SegregatedDataEncryptionFormVM;
}

const SegregatedDataEncryptionFormPresentation = observer(
    (props: ISegregatedDataEncryptionFormPresentationProps) => {
        const { vm } = props;

        return (
            <CommonPopupBodyFooterLayout
                body={
                    <>
                        <div className='oe-form'>
                            <div className='oe-form__body'>
                                <div className='m-top-10px m-bottom-0px flex center'>
                                    <OEToggle
                                        isSelected={vm.settingsEntity.enabled}
                                        onClick={vm.settingsEntity.toggleEnabled}
                                    />
                                    <Text
                                        {...SEGREGATED_DATA_ENCRYPTION_TOGGLE_TEXT}
                                        values={{
                                            suffix: vm.settingsEntity.suffix
                                        }}
                                        className='line-height-25px'
                                    />
                                </div>
                                <div className='segregated-data-modal-info'>
                                    <FormattedMessage
                                        {...SEGREGATED_DATA_ENCRYPTION_INFO_TEXT}
                                        values={{ br: <br /> }}
                                    />
                                </div>
                                <div className='segregated-data-modal-info'>
                                    <FormattedMessage
                                        {...SEGREGATED_DATA_ENCRYPTION_CLIENTS_INFO_TEXT}
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                }
                footer={
                    <AccountAdminSettingFormFooter
                        handleClose={vm.handleClose}
                        handleSubmit={vm.handleSubmit}
                        isDisabled={vm.saving}
                    />
                }
            />
        );
    }
);

export { SegregatedDataEncryptionFormPresentation };
